import $ from 'jquery';
import slick from 'slick-carousel';

import breakpoints from '../utils/breakpoints';
import mq from '../utils/media-queries';

export default {
  initialized: false,

  init() {
    const unslick = breakpoints['netbook'];

    const $carousel = $('.featured-posts__carousel');
    const settings = {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: false,
      infinite: false,
      responsive: [
        {
          breakpoint: breakpoints['tinytab'],
          settings: {
            centerMode: true,
            centerPadding: '10%',
          }
        },
        {
          breakpoint: breakpoints['tablet'],
          settings: {
            centerMode: true,
            centerPadding: '20%',
          }
        },
        {
          breakpoint: unslick,
          settings: 'unslick'
        }
      ]
    };

    $carousel.on('init reInit', (event, slick) => {
      this.initialized = true;
    });

    $carousel.on('destroy', (event, slick) => {
      this.initialized = false;
    });

    mq.onMaxWidth(unslick, () => {
      if ( !this.initialized ) $carousel.slick(settings);
    });

  },

}

